import React from "react";

export const OtpContext = React.createContext();